import { render, staticRenderFns } from "./DemoCountdownBar.vue?vue&type=template&id=64335897&scoped=true"
import script from "./DemoCountdownBar.vue?vue&type=script&lang=ts"
export * from "./DemoCountdownBar.vue?vue&type=script&lang=ts"
import style0 from "./DemoCountdownBar.vue?vue&type=style&index=0&id=64335897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64335897",
  null
  
)

export default component.exports